export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/ob-step-10.png?9db3e4ecb6562148d7b43618a8e64f42";